export const setRedirectUrl = ({ commit }, url) => {
  commit('setRedirectUrl', url)
}
